/**
 * <SubjectBadgeSkeleton> — la place d'une chip de matière d'affichage, sans libellé, pendant un
 * chargement (atom).
 *
 * Sa boîte et son rayon sont ceux de la chip (`SIZE_TOKENS`, `subjectBadgeIconBox`) : une retouche
 * de la chip se voit dans chaque squelette qui la pose, sans recopie.
 */
import React from "react"

import { Skeleton } from "../Skeleton"
import { SIZE_TOKENS, subjectBadgeIconBox } from "./SubjectBadge"

const BOX = subjectBadgeIconBox("sm")

export function SubjectBadgeSkeleton() {
    return <Skeleton shape="block" width={BOX.width} height={BOX.height} radius={SIZE_TOKENS.sm.radius} />
}
